<template>
  <div>
      <div :style="{height: params.height + 'px', backgroundColor: params.backgroundColor}"></div>
  </div>
</template>

<script>
export default {
    props: {
        params: {
            type: [Object, Array]
        }
    },
}
</script>

<style>

</style>